
define(
	'Code25.PO'
	, [
		"underscore", "jQuery", "Profile.Model"
	]
	, function (
		_, jQuery, ProfileModel
	) {
		'use strict';

		return {
			mount: function (container) {

				var OrderWizardModulePaymentMethodPurchaseNumber = require("OrderWizard.Module.PaymentMethod.PurchaseNumber");


				_.extend(OrderWizardModulePaymentMethodPurchaseNumber.prototype, {
					initialize: _.wrap(OrderWizardModulePaymentMethodPurchaseNumber.prototype.initialize, function (initialize) {


						initialize.apply(this, _.rest(arguments));

						var purchasenumber = this.model.get("purchasenumber");

						var billaddress = this.model.get("billaddress");
						var shipaddress = this.model.get("shipaddress");

						var profile = ProfileModel.getInstance();
						var addresses = profile.get("addresses").models, internalid, billpo, shippo;
						for (var i = 0; i < addresses.length; i++) {
							internalid = addresses[i].get("internalid");

							if (internalid == billaddress) {
								billpo = addresses[i].get("purchaseorder");
							} else if (internalid == shipaddress) {
								shippo = addresses[i].get("purchaseorder");
							}
						}
						if ((!purchasenumber&&(shippo || billpo))||(shippo&&billpo&&shippo!=billpo&&purchasenumber==billpo)) {
								this.model.set("purchasenumber", shippo || billpo);
						}
					})
				});
			}
		};

	});
